import {useCompositeState} from "pages/role/CompositesState"
import {SelectBox} from "pages/common/SelectBox"

interface CompositesProps {
    roleName: string
}

export function Composites({roleName}: CompositesProps) {
    const {
        sourceList,
        setSourceItem,
        addComposite,
        setTargetItem,
        deleteComposite,
        targetList
    } = useCompositeState(roleName)
    return (
        <>
            {/*<div className="hr-line-dashed mt30"></div>*/}
            <div className="columns mt20">
                <div className="column">
                    <div className=" ml20">
                        <div className="gray-label is-size-85">사용가능한 Roles</div>
                        <SelectBox items={sourceList} onChangeItem={(item) => setSourceItem(item)} themeColor="green"/>
                        <div className="mt10">

                            <div className="is-clickable button is-success is-size-85" onClick={() => addComposite()}>
                                <span>선택추가</span>
                                <span className="icon">
                                    <i className="fa-solid fa-angles-right"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="column">
                    <div className=" ml20">
                        <div className="gray-label is-size-85">선택된 Roles</div>
                        <SelectBox items={targetList} onChangeItem={(item) => setTargetItem(item)} themeColor="blue"/>
                        <div className="mt10">
                            <div className="is-clickable button is-info is-size-85" onClick={() => deleteComposite()}>
                                <span className="icon">
                                    <i className="fa-solid fa-angles-left"></i>
                                </span><span>선택삭제</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

